<template>
  <AppModal :close="close" :isOpen="isOpen" :spacing="false" size="sm">
    <div class="content-modal">
      <div class="content-modal__heading">
        <AppHeading size="sm" theme="black">
          <TextContent :content="headline" />
        </AppHeading>
      </div>
      <div class="content-modal__body">
        <slot />
      </div>
    </div>
  </AppModal>
</template>

<script>
import AppModal from './AppModal';
import AppHeading from './AppHeading';
import TextContent from './TextContent';

export default {
  components: {
    AppHeading,
    AppModal,
    TextContent
  },
  props: {
    headline: {
      type: String,
      required: false,
      default: ''
    },
    close: {
      type: Function,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.content-modal {
  padding-block: spacing('lg');

  @include breakpoint('md') {
    padding-block: spacing('xl');
  }

  &__heading {
    padding: spacing('xl') 0 spacing('xl') 0;
    text-align: center;
  }

  &__body {
    padding: 0 spacing('xl', 2);
  }
}
</style>
